<template>
  <Container
    :on-load-data="init"
    class="container"
    no-data-title="暂无门店详情"
  >
    <AppBar
      slot="appbar"
      immersive
    />
    <template slot-scope="{ data: shopDetail }">
      <van-swipe class="swipe-banner">
        <van-swipe-item
          v-for="(image, index) in shopDetail.shopImages"
          :key="index"
          @click.stop="imagePreview(shopDetail.shopImages)"
        >
          <van-image
            class="swipe-img"
            fit="cover"
            :src="image"
          >
            <div slot="error">
              <van-image
                class="swipe-img"
                fit="cover"
                :src="placeholderImg"
              />
            </div>
          </van-image>
        </van-swipe-item>
      </van-swipe>

      <!-- 门店卡片 -->
      <store-card :item="shopDetail" />

      <div class="package-container">
        <template v-if="shopDetail && shopDetail.tabSort && shopDetail.tabSort.length">
          <div class="package-title">
            商品介绍
          </div>
          <div class="package-desc">
            具体商品详情请致电门店或线下门店购买
          </div>
          <div class="wrap">
            <van-sticky>
              <div style="height: var(--status-bar-height); background: #fff;" />
              <van-tabs
                v-model="activeTapIndex"
                class="tabs"
                title-active-color="#242729"
                title-inactive-color="#879099"
                :line-width="pxtorem(26)"
                line-height="2"
                swipe-threshold="3"
              >
                <van-tab
                  v-for="tab in showTabs(shopDetail.tabSort || [])"
                  :key="tab && tab.code"
                  :title="tab && tab.name"
                  :disabled="!tab"
                />
              </van-tabs>
            </van-sticky>
          </div>
          <div class="packages">
            <GoodsCard
              v-for="(item, index) in packages(shopDetail.tabSort || [])"
              :key="index"
              :item="item"
            />
          </div>
        </template>
        <NoData
          v-else
          class="nodata"
          :img="nodataImage"
          title="该城市未配置套餐，请耐心等待"
        />
      </div>
      <div class="footer-place" />
      <div class="footer safe-area-inset-bottom">
        <img
          class="logo"
          :src="logo"
        >
      </div>
    </template>
  </Container>
</template>

<script>
import { queryShopDetailInfo } from '@/api/shop';
import logo from '@/assets/shop/logo.png';
import placeholderImg from '@/assets/shop/placeholderImg.png';
import {
  Tabs, Tab, Swipe, SwipeItem, Sticky, Image, ImagePreview,
} from 'vant';
import { pxtorem, mapVant, noop } from '@/utils';
import { dispatchRenderEvent } from '@/utils/preRender';
import NoData from '@/components/empty/NoData.vue';
import imagesMap from '@/const/images';
import Container from '@/components/Container';
import GoodsCard from './components/GoodsCard/index.vue';
import StoreCard from './components/StoreCard';

const arrayFix = (arr, length, item) => {
  if (arr.length < length) {
    return arrayFix([...arr, item], length, item);
  }
  return arr;
};

export default {
  components: {
    ...mapVant(
      Tab,
      Tabs,
      Swipe,
      SwipeItem,
      Sticky,
      Image,
      ImagePreview,
    ),
    StoreCard,
    GoodsCard,
    Container,
    NoData,
  },
  data() {
    return {
      nodataImage: imagesMap.loadFailedImg,
      logo,
      placeholderImg,
      activeTapIndex: 0, // 选中的tab 索引
      shopId: this.$route.query.shopId,
      merchantId: this.$route.query.merchantId,
    };
  },
  methods: {
    pxtorem,
    async init() {
      if (window.__PRERENDER_INJECTED) {
        // 预渲染时不发送请求，使用默认值渲染页面
        dispatchRenderEvent();
        // 预渲染时停在loading页
        await new Promise(noop);
        return true;
      }
      return this.queryShopDetail();
    },

    async queryShopDetail() {
      const { cityCode, adCode } = await this.$store.dispatch('location/getLocation');
      return queryShopDetailInfo({
        shopId: this.shopId,
        merchantId: this.merchantId,
        cityCode: cityCode || '010',
        adCode: adCode || '110101',
      });
    },

    imagePreview(images = []) {
      ImagePreview({
        images,
        closeable: true,
      });
    },

    showTabs(tabs) {
      return arrayFix(tabs, 4);
    },

    packages(tabs) {
      return ((tabs || [])[this.activeTapIndex] || {}).list || [];
    },
  },
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>
